var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(_vm.item.avatar)?_c('img',{staticClass:"rounded-circle",staticStyle:{"object-fit":"cover","padding":"0!important"},attrs:{"src":_vm.item.avatar,"alt":"Avatar","width":_vm.size,"height":_vm.size}}):_c('vue-letter-avatar',{attrs:{"name":_vm.name,"size":String(_vm.size),"rounded":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }